module.exports = __webpack_public_path__ + "img/aeroland-branding-image-12.343df42d.png";